/* Entry point. Import order matters and mirrors the original three <script>
   blocks: the game core wires the DOM and defines the app state, chain.ts then
   attaches the wallet/deposit layer on top of it, and referral.ts last. */
import "./styles.css";
import { IS_DEMO_BUILD } from "./core";

/* MUST precede ./core-game. Telegram has to be told to stop hijacking vertical
   drags and to expand before the scratch canvas measures itself. Imports are
   hoisted, so this ordering — not a call in the body — is what sequences it. */
import "./mobile-boot";
import "./core-game";
import "./chain";
import "./referral";
import { startWinsFeed } from "./chain/wins";

/* Live wins sidebar. Reads settled Played events from the contract; renders an
   idle state rather than inventing activity when nothing is configured. */
startWinsFeed();

/* Demo/QA machinery. `IS_DEMO_BUILD` is a compile-time literal, so in the
   production build this collapses to `if (false)` and Rollup drops the import
   and every module reachable only from it. Verified by `npm run guard`. */
if (IS_DEMO_BUILD) {
  /* Not awaited: top-level await would force the bundle target up to es2022,
     and nothing here depends on the strip being ready. */
  void import("./demo");
}
